<template>
  <el-checkbox class="ui-checkbox" :class="{ 'ui-checkbox--muted': muted }" v-bind="$attrs" v-on="$listeners">
    <slot />
  </el-checkbox>
</template>

<script>
export default {
  name: 'UiCheckbox',
  inheritAttrs: false,
  props: { muted: { type: Boolean, default: false } }
}
</script>

<style lang="scss">
:is(.ui-checkbox, .ui-table .el-checkbox) {
  color: var(--ui-text-regular);
  font-size: var(--ui-font-size-form-control);
  font-weight: 400;
}

:is(.ui-checkbox, .ui-table .el-checkbox) .el-checkbox__inner {
  border-color: var(--ui-border-color-strong);
  background: var(--ui-bg-control);
  transition: border-color var(--ui-duration-fast) ease,
    background-color var(--ui-duration-fast) ease,
    box-shadow var(--ui-duration-fast) ease;
}

:is(.ui-checkbox, .ui-table .el-checkbox) .el-checkbox__input.is-checked .el-checkbox__inner,
:is(.ui-checkbox, .ui-table .el-checkbox) .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: var(--ui-color-primary);
  background: var(--ui-color-primary-active);
}

:is(.ui-checkbox, .ui-table .el-checkbox) .el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--ui-color-primary);
}

/* 原生 input 在 inner 之后，通过容器焦点呈现键盘环，兼容现有 PostCSS/WebView。 */
:is(.ui-checkbox, .ui-table .el-checkbox):focus-within .el-checkbox__input:not(.is-disabled) .el-checkbox__inner {
  box-shadow: 0 0 0 3px rgba(var(--ui-color-primary-rgb), .16);
}

:is(.ui-checkbox, .ui-table .el-checkbox):active:not(.is-disabled) .el-checkbox__inner {
  transform: scale(.9);
}

@media (hover: hover) and (pointer: fine) {
  :is(.ui-checkbox, .ui-table .el-checkbox):not(.is-disabled):not(.is-checked):hover .el-checkbox__inner {
    border-color: var(--ui-color-primary);
  }
}
/* 轻量筛选项只改变色调，保留同一复选框的尺寸与交互。 */
.ui-checkbox.ui-checkbox--muted .el-checkbox__input.is-checked .el-checkbox__inner,
.ui-checkbox.ui-checkbox--muted .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: var(--ui-text-secondary);
  background: var(--ui-text-secondary);
}
.ui-checkbox.ui-checkbox--muted .el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--ui-text-regular);
}
.ui-checkbox.ui-checkbox--muted .el-checkbox__input.is-checked .el-checkbox__inner::after {
  border-color: var(--ui-bg-control);
}
</style>
